__webpack_require__.p = "/wp-content/themes/base-habitations/dist/";